export const addAssets = assets => {
    if (window.e2_assets_initialized) {
        window.e2_assets = { ...window.e2_assets, ...assets };
    } else {
        window.e2_assets = { ...assets };
        window.e2_assets_initialized = true;
    }
};
